import React from "react";
import { Helmet } from "react-helmet-async";
import { useLang, LANGS } from "../i18n/LanguageContext";
import { SEO, SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE, buildJsonLd } from "../i18n/seo";

// pageKey: "home" | "philosophy" | "method" | "services" | "founder" | "journal" | "apply"
// path: route path (e.g. "/", "/philosophy")
export const Seo = ({ pageKey, path = "/", jsonLd = false, image }) => {
  const { lang } = useLang();
  const meta = (SEO[lang] && SEO[lang][pageKey]) || SEO.en[pageKey];
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const ogImage = `${SITE_URL}${image || DEFAULT_OG_IMAGE}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <link rel="canonical" href={canonical} />

      {/* hreflang — the SPA serves all languages on the same URL, so we self-reference. */}
      {LANGS.map((l) => (
        <link key={l.code} rel="alternate" hrefLang={l.code} href={canonical} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={canonical} />

      {/* Open Graph */}
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={lang === "en" ? "en_US" : `${lang}_${lang.toUpperCase()}`} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={meta.description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={meta.description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Robots */}
      <meta name="robots" content="index, follow, max-image-preview:large" />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(buildJsonLd())}</script>
      )}
    </Helmet>
  );
};
